module.exports = __webpack_public_path__ + "static/media/servicio1.a921969e.jpg";